import React, { Component } from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class CrispBankFilter extends Component {
    state = {
        bankList: [],
        selectedBanks: [],
        isBankListLoading: true
    };

    componentDidMount() {
        this.getCrispBankList();
    }

    resetCrispBankFilter() {
        this.setState({
            selectedBanks: [],
        });
    }

    getCrispBankList() {
        axios.get(config.get('API_URL') + '/filters/get-crisp-bank/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_type: this.props.userType,
            }
        }).then(response => {
            if (Array.isArray(response.data) && response.data.length) {
                const bankList = response.data.map(item => ({
                    value: item.bank_name,
                    label: item.bank_name
                }));
                this.setState({
                    bankList,
                    isBankListLoading: false
                });
            }
        });
    }

    changeCrispBank(optionSelected) {
        let selectedBanks = optionSelected.map(item => item.value);

        // Optional: reordering selected to top
        optionSelected.forEach((item) => {
            const index = this.state.bankList.findIndex(obj => obj.value === item.value);
            this.state.bankList.move(index, 0).join(',');
        });

        this.props.onSelectCrispBank(optionSelected, selectedBanks);

        this.setState({
            selectedBanks: optionSelected
        });
    }

    render() {
        return (
            <ReactMultiSelectCheckboxes
                name="crisp_bank"
                isMulti
                value={this.state.selectedBanks}
                styles={reactSelectStyles}
                className="report-listbox"
                isClearable={false}
                onChange={this.changeCrispBank.bind(this)}
                options={this.state.bankList}
                placeholderButtonLabel="Select [Bank]"
                isLoading={this.state.isBankListLoading}
            />
        );
    }
}

export default CrispBankFilter;
